import imageCompression from 'browser-image-compression';

// 压缩图片
export const compressImage = async (file, options = {}) => {
  const defaultOptions = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    fileType: file.type
  };

  try {
    const compressedFile = await imageCompression(file, {
      ...defaultOptions,
      ...options
    });
    return compressedFile;
  } catch (error) {
    console.error('图片压缩失败:', error);
    throw error;
  }
};

// 创建图片预览URL
export const createPreviewUrl = (file) => {
  return URL.createObjectURL(file);
};

// 释放预览URL
export const revokePreviewUrl = (url) => {
  URL.revokeObjectURL(url);
};

// 修正图片URL（添加API基础URL）
export const fixImageUrl = (imageUrl, baseUrl) => {
  if (!imageUrl) return '';
  
  // 处理对象类型的URL（如签名图片URL对象）
  if (typeof imageUrl === 'object' && imageUrl !== null) {
    // 如果是包含 url 属性的对象
    if (imageUrl.url) {
      return fixImageUrl(imageUrl.url, baseUrl);
    }
    // 如果是其他类型的对象，返回空字符串
    console.warn('无法处理的图片URL对象:', imageUrl);
    return '';
  }
  
  // 确保 imageUrl 是字符串
  if (typeof imageUrl !== 'string') {
    console.warn('非字符串类型的图片URL:', imageUrl, typeof imageUrl);
    return '';
  }
  
  // 如果已经是完整URL，检查是否需要替换域名
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    // 如果是 warehouseapi 域名，则替换为图片服务器域名
    if (imageUrl.includes('warehouseapi.proxypool.eu.org')) {
      return imageUrl.replace('warehouseapi.proxypool.eu.org', 'imgapi.proxypool.eu.org');
    }
    return imageUrl;
  }
  
  // 否则添加基础URL
  return `${baseUrl}/${imageUrl.startsWith('/') ? imageUrl.substring(1) : imageUrl}`;
};
